import { useEffect } from 'react';

import { pwaMediaQuery } from 'app/middleware/visibility/utils/helpers';
import { useMediaQuery } from 'utils/mediaQuery';

import { useJabraDevices } from './utils/useJabraDevices/useJabraDevices';

/**
 * Checks feature flag, PWA and electron and initializes the jabra devices with
 * web usb
 */
export const useJabraInit = (): void => {
  const [isOpenedInPWA] = useMediaQuery(pwaMediaQuery);
  const [initJabra, removeJabra] = useJabraDevices();

  useEffect(() => {
    // Detect PWA and initialize or remove Jabra.
    if (isOpenedInPWA) {
      initJabra();
    } else {
      removeJabra();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenedInPWA]);
};
